module.exports = __webpack_public_path__ + "img/shop-bg-bak.b9252758.png";